/** 방별 참여 세션(참여자 ID + 재접속 토큰)을 브라우저에 저장합니다. */
export interface RoomSession {
  participantId: string;
  token: string;
  nickname: string;
  savedAt: number;
}

const PREFIX = 'wtet:session:';

function key(roomId: string): string {
  return `${PREFIX}${roomId}`;
}

export function loadSession(roomId: string): RoomSession | null {
  try {
    const raw = localStorage.getItem(key(roomId));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<RoomSession>;
    if (typeof parsed.participantId !== 'string' || typeof parsed.token !== 'string') return null;
    return { participantId: parsed.participantId, token: parsed.token, nickname: parsed.nickname ?? '', savedAt: parsed.savedAt ?? 0 };
  } catch {
    return null;
  }
}

export function saveSession(roomId: string, session: Omit<RoomSession, 'savedAt'>): void {
  try {
    localStorage.setItem(key(roomId), JSON.stringify({ ...session, savedAt: Date.now() }));
    pruneOldSessions();
  } catch {
    /* 저장 불가(시크릿 모드 등)여도 서비스는 동작 */
  }
}

export function clearSession(roomId: string): void {
  try {
    localStorage.removeItem(key(roomId));
  } catch {
    /* ignore */
  }
}

/** 하루 이상 지난 세션 정리 */
function pruneOldSessions(): void {
  const cutoff = Date.now() - 24 * 60 * 60 * 1000;
  for (let i = localStorage.length - 1; i >= 0; i -= 1) {
    const k = localStorage.key(i);
    if (!k || !k.startsWith(PREFIX)) continue;
    try {
      const parsed = JSON.parse(localStorage.getItem(k) ?? '{}') as Partial<RoomSession>;
      if ((parsed.savedAt ?? 0) < cutoff) localStorage.removeItem(k);
    } catch {
      localStorage.removeItem(k);
    }
  }
}
